import './Grafica.scss';
import {
    ArrowUpRight,
    Boxes,
    Brush,
    Palette,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import {YouTubeIcon} from "../../../Images/Icon/Icon";
import {useTranslation} from "react-i18next";

type GraficaItem = {
    number: string;
    href: string;
    icon: 'youtube' | 'minecraft' | 'loghi' | 'disegni';
    accent: 'red' | 'green' | 'orange' | 'purple';
};

const servizi: GraficaItem[] = [
    {
        number: '01',
        href: '/servizi/grafica/youtube-thumbnail',
        icon: 'youtube',
        accent: 'red',
    },
    {
        number: '02',
        href: '/servizi/grafica/minecraft',
        icon: 'minecraft',
        accent: 'green',
    },
    {
        number: '03',
        href: '/servizi/grafica/logos',
        icon: 'loghi',
        accent: 'orange',
    },
    {
        number: '04',
        href: '/servizi/grafica/drawings',
        icon: 'disegni',
        accent: 'purple',
    },
];

function GraficaIcon({ type }: { type: GraficaItem['icon'] }) {
    switch (type) {
        case 'youtube':
            return <YouTubeIcon/>;
        case 'minecraft':
            return <Boxes strokeWidth={1.6} />;
        case 'loghi':
            return <Brush strokeWidth={1.6} />;
        case 'disegni':
            return <Palette strokeWidth={1.6} />;
    }
}

export default function Grafica() {
    const { t } = useTranslation();
    return (
        <section className="grafica-section" id="grafica">
            <div className="grafica-orb grafica-orb--left" />
            <div className="grafica-orb grafica-orb--right" />

            <div className="grafica-container">
                <header className="grafica-header">
                    <h2>
                        {t(`services.graphic.title.normal`)}
                        <span> {t(`services.graphic.title.bold`)}</span>
                    </h2>

                    <p>
                        {t(`services.graphic.subtitle`)}
                    </p>
                    <div className="grafica-header__eyebrow">
                        <span className="grafica-header__line" />
                        <span>{t(`services.graphic.graphic`)}</span>
                        <span className="grafica-header__line" />
                    </div>
                </header>

                <div className="grafica-grid">
                    {servizi.map((servizio) => (
                        <Link
                            key={servizio.number}
                            to={servizio.href}
                            className={`grafica-card grafica-card--${servizio.accent}`}
                            aria-label={`Scopri il servizio ${t(`services.graphic.card.${servizio.number}.title`)}`}
                        >
                            <div className="grafica-card__glow" />

                            <div className="grafica-card__top">
                                <span className="grafica-card__category">
                                    {t(`services.graphic.card.${servizio.number}.title`)}
                                </span>
                            </div>

                            <div className="grafica-card__main">
                                <div className="grafica-card__icon">
                                    <div className="grafica-card__icon-glow" />
                                    <GraficaIcon type={servizio.icon} />
                                </div>

                                <div className="grafica-card__content">
                                    <h3 className="grafica-card__title">
                                        {t(`services.graphic.card.${servizio.number}.title`)}
                                    </h3>

                                    <p className="grafica-card__description">
                                        {t(`services.graphic.card.${servizio.number}.subtitle`)}
                                    </p>
                                </div>
                            </div>

                            <div className="grafica-card__bottom">
                                <span className="grafica-card__cta">
                                    Scopri il servizio
                                </span>

                                <span className="grafica-card__arrow">
                                    <ArrowUpRight strokeWidth={1.8} />
                                </span>
                            </div>

                            <div className="grafica-card__shine" />
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}